export enum VatTaxationType {
    IsSubjectToVat,
    IsNotSubjectToVat
}